import config from '../config'
import req from '../util/request'

export default {
  /**
   * 创建小程序码
   * @see https://yapi.geekbang.org/project/345/interface/api/21030
   * @see https://developers.weixin.qq.com/miniprogram/dev/api-backend/open-api/qr-code/wxacode.getUnlimited.html
   * @param {Object} data
   * @param {String} data.app_id 小程序的 AppID
   * @param {String} data.page 小程序页面路径（最前面没有斜杠）
   * @param {String} data.scene 参数（不超过32位， 例如 sku=xxx&code=xxx)
   * @param {Boolean} data.auto_color （非必填）是否自动设置线条颜色，默认 false
   * @param {Object} data.line_color (非必填) 线条颜色，auto_color 为 false 时生效
   * @param {String} data.env_version 小程序版本 正式版为 release，体验版为 trial，开发版为 develop
   * @returns
   */
  getMpCode (data) {
    return req({
      url: `${config.miscServer}/wxmisc/acode/create`,
      responseType: 'blob',
      data
    })
  }
}
